if (!customElements.get('newsletter-form')) {
  customElements.define(
    'newsletter-form',
    class NewsletterForm extends HTMLElement {
      constructor() {
        super();

        this.successElementId = this.getAttribute('success-element-id');
        this.contentElementId = this.getAttribute('content-element-id');
        this.newsletterId = this.getAttribute('newsletter-id');
        this.form = this?.querySelector('form');
        this.emailInput = this?.querySelector('input[type="email"]');
        this.acceptInput = this?.querySelector('input[type="checkbox"]');
        this.submitButton = this?.querySelector('button[type="submit"]');
        this.isCurrentNewsletterActive = this.isCurrentNewsletter();

        if (this.submitButton) {
          this.submitButton.disabled = false;
        }

        this.attachEventHandlers();
      }

      attachEventHandlers() {
        this.emailInput.addEventListener(
          'blur',
          this.onEmailBlurHandler.bind(this)
        );
        this.acceptInput.addEventListener(
          'change',
          this.onAcceptChangeHandler.bind(this)
        );

        if (this.submitButton) {
          this.submitButton.addEventListener(
            'click',
            this.onButtonClickHandler.bind(this)
          );
        }

        this.handleShowSuccessMessage();
        this.handleNewsletterContent();
      }

      onEmailBlurHandler() {
        this.validateInput(
          this.emailInput,
          this.validateEmail(this.emailInput.value.trim())
        );
      }

      onAcceptChangeHandler() {
        this.validateInput(this.acceptInput, this.acceptInput.checked);
      }

      onButtonClickHandler(event) {
        const emailValid = this.validateInput(
          this.emailInput,
          this.validateEmail(this.emailInput.value.trim())
        );
        const acceptValid = this.validateInput(
          this.acceptInput,
          this.acceptInput.checked
        );

        if (!emailValid || !acceptValid) {
          event.preventDefault();
          (emailValid ? this.acceptInput : this.emailInput).focus();
        }
      }

      handleNewsletterContent() {
        const contentElement = document?.getElementById(this.contentElementId);
        const newsletterStatus =
          contentElement?.dataset?.newsletterStatus || 'false';
        const isForce =
          newsletterStatus == 'true' && this.isCurrentNewsletterActive;

        if (!contentElement) {
          return null;
        }

        contentElement.classList.toggle('hidden', isForce);
      }

      handleShowSuccessMessage() {
        const successElement = document?.getElementById(this.successElementId);
        const newsletterStatus =
          successElement.dataset.newsletterStatus || 'false';
        const isForce =
          newsletterStatus == 'true' && this.isCurrentNewsletterActive;

        if (!successElement) {
          return null;
        }

        successElement.classList.toggle('hidden', !isForce);
      }

      validateInput(input, isValid) {
        if (isValid) {
          this.hideInputError(input);
        } else {
          const errorType =
            input.type === 'email' && input.value.trim() ? 'email' : 'required';
          this.renderInputError(input, errorType);
        }

        return isValid;
      }

      validateEmail(email) {
        const emailRegex =
          /^[a-zA-Z0-9](?:[a-zA-Z0-9._%+-]*[a-zA-Z0-9])?@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
      }

      getTargetElement(input) {
        return input.type === 'checkbox' ? input.parentNode : input;
      }

      getErrorMessage(input, type = 'Required') {
        const { dataset } = input;
        const errorDataType = `error${
          type.charAt(0).toUpperCase() + type.slice(1)
        }`;
        return dataset[errorDataType] || '';
      }

      getURLHashValue() {
        const queryString = window.location.search;
        const hashValue = window.location.hash?.split('#')[1];
        const urlParams = new URLSearchParams(queryString);
        const customerPosted = urlParams.get('customer_posted');
        const isCustomerPosted = customerPosted == 'true';

        return isCustomerPosted ? hashValue : null;
      }

      isCurrentNewsletter() {
        const hashValue = this.getURLHashValue();

        return this.newsletterId == hashValue;
      }

      getErrorElement(input) {
        const error = this.getTargetElement(input).nextElementSibling;

        return error?.classList?.contains('js-input-error') ? error : null;
      }

      renderInputError(input, type = 'Required') {
        if (!input) return;

        const error = this.getErrorElement(input);

        input.classList?.add('has-error');
        input.setAttribute('aria-invalid', 'true');

        if (error) {
          input.setAttribute('aria-describedby', error.id);
          error.textContent = this.getErrorMessage(input, type);
        }
      }

      hideInputError(input) {
        if (!input) return;

        const error = this.getErrorElement(input);

        input.classList?.remove('has-error');
        input.setAttribute('aria-invalid', 'false');
        input.removeAttribute('aria-describedby');

        if (error) {
          error.textContent = '';
        }
      }
    }
  );
}
